import { render } from "./DeliveryMethods.vue?vue&type=template&id=6975de9c"
import script from "./DeliveryMethods.vue?vue&type=script&lang=js"
export * from "./DeliveryMethods.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__